var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCircleDash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53053 0.00476335C7.48879 0.00891689 7.35647 0.0211309 7.23648 0.0319226C4.26777 0.298565 1.65056 2.26444 0.551371 5.05336C0.164857 6.03402 0 6.91415 0 7.99705C0 8.627 0.0364999 9.02544 0.143268 9.56174C0.560685 11.6581 1.80283 13.4977 3.60385 14.6867C5.19149 15.7349 7.13221 16.1809 9.02729 15.9331C10.0443 15.8001 11.0574 15.4639 11.9194 14.9734C13.8669 13.8652 15.2433 12.05 15.7712 9.89364C16.2989 7.73818 15.9041 5.44973 14.6868 3.60674C13.7708 2.22006 12.4633 1.15524 10.9398 0.55506C10.2345 0.277228 9.58214 0.118749 8.78261 0.0310502C8.59138 0.0100549 7.67137 -0.00923352 7.53053 0.00476335ZM4.29598 7.99705V8.58499H7.99531H11.6946V7.99705V7.40911H7.99531H4.29598V7.99705Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleDash);
export default __webpack_public_path__ + "static/media/icon--circle-dash.1e7803d2fbf523a4c00f2829b9149ce3.svg";
export { ForwardRef as ReactComponent };